<template>
  <div id="projetsetup">
    <div class="right">
      <div class="right_header">绘图仪配置文件</div>
      <div v-if="uploadFile" class="right_button">
        <el-button type="primary" size="small" @click="uploadBtn">上传</el-button>
      </div>
      <div class="right_table">
        <el-table v-loading="loading" :data="tableData" border element-loading-text="拼命加载中"
          highlight-current-row height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size:16px;color:#000;margin-top:36px">暂无数据</p>
          </template>
          <el-table-column label="文件名称" prop="fileName">
            <template slot-scope="{ row }">
              <div style="display:flex;align-items: center">
                <img :src="icon" style="margin-right:8px" alt="" />
                <span>{{ row.fileName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="createTime" min-width="120px" />
          <el-table-column label="文件大小" prop="fileSizeStr" />
          <el-table-column label="适配版本" prop="cadVersionName" />
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deleteRow(scope.row)">
                删除
              </el-button>
              <el-button type="text" size="mini" @click="download(scope.row)">
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog v-dialogDrag title="上传" :visible.sync="plotterConfigDialog" :before-close="clickClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
      <el-form ref="plotterConfigForm" :model="plotterConfigForm" :rules="rules" size="small">
        <el-form-item label="文件:" prop="fileList">
          <el-upload ref="upload" :limit="1" :disabled="upload" :file-list="plotterConfigForm.fileList" :auto-upload="false"
            :http-request="httpRequest" :on-change="uploadChange" :on-remove="onRemove" accept=".pc3,.pc5" class="upload-file"
            style="display: inline-block; margin: 0 10px" action="/">
            <el-button type="primary" size="small" plain>上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传pc3/pc5格式文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本选择:" prop="cadVersionId">
          <el-select v-model="plotterConfigForm.cadVersionId" style="width: 100%" clearable filterable>
            <el-option v-for="item in cadVersionList" :key="item.id" :value="item.id" :label="item.cnName" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clickClose">取 消</el-button>
        <el-button type="primary" size="small" @click="plotterConfigConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import print from "@/CommonDP/service/plotterConfig-service.js";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import dicService from "@/CommonDP/service/dic-service.js";
export default {
  name: "ConfigurationFile",
  data() {
    return {
      loading: false,
      tableData: [],
      icon: require("@/CommonDP/assets/standard/img.png"),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      uploadFile: checkPermission(this.$allPerms.CONFIGURATIONFILE_UPLOAD),
      upload: false,
      plotterConfigDialog: false,
      plotterConfigTypeList: [],
      plotterConfigForm: {
        cadVersionId: '',
        fileList: []
      },
      rules: {
        cadVersionId: [{ required: true, message: "请选择版本", trigger: "change" }],
        fileList: [{ required: true, message: "请先上传文件", trigger: "blur" }]
      },
      cadVersionList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.getList();
    this.queryPlotterConfigTypeList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await print.queryPlotterConfigList(this.enterpriseId);
      if (res.result === "0") {
        this.tableData = res.data;
        this.loading = false;
      }
    },
    async httpRequest({ file }) {
      const data = new FormData();
      const { cadVersionId } = this.plotterConfigForm;
      data.append("file", file);
      data.append("enterpriseId", this.enterpriseId);
      data.append("cadVersionId", cadVersionId);
      console.log(data, 'data');
      const res = await print.uploadPlotterConfig(data);
      if (res.result === "0") this.$message.success("上传成功");
      this.clickClose();
      this.getList();
    },
    deleteRow(val) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("是否确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            print.deletePlotterConfig(val.id).then((res) => {
              if (res.result === "0") {
                this.$message({
                  duration: 1000,
                  message: "删除成功",
                  type: "success",
                  showClose: true
                });
                this.getList();
              }
            });
          })
          .catch(() => {});
      }
    },
    // 上传
    uploadBtn() {
      this.plotterConfigDialog = true;
    },
    clickClose() {
      this.$refs.plotterConfigForm.resetFields();
      this.plotterConfigForm.fileList = [];
      this.plotterConfigDialog = false;
    },
    async plotterConfigConfirm() {
      await this.$refs.plotterConfigForm.validate();
      this.$refs.upload.submit();
    },
    uploadChange(file, fileList) {
      const type = file.name.replace(/.+\./, "");
      if (this.tableData.length > 0 && this.tableData.some((e) => e.fileName === file.name)) {
        this.plotterConfigForm.fileList = [];
        this.$message.warning(`文件${file.name}上传失败，已存在同名文件`);
        return;
      }
      this.plotterConfigForm.fileList = fileList;
      this.$refs.plotterConfigForm.validateField("fileList");
      this.plotterConfigForm.cadVersionId = '';
      if (type === 'pc3') {
        this.cadVersionList = this.plotterConfigTypeList.filter((item) => item.cnName === 'AutoCAD' || item.cnName === '浩辰CAD');
      } else {
        this.cadVersionList = this.plotterConfigTypeList.filter((item) => item.cnName.search("中望") !== -1);
      }
    },
    onRemove(file, fileList) {
      this.plotterConfigForm.fileList = [];
      this.$refs.plotterConfigForm.validateField("fileList");
      this.plotterConfigForm.cadVersionId = '';
      this.cadVersionList = [];
    },
    async queryPlotterConfigTypeList() {
      const { data } = await dicService.getDicList('printCadVersion');
      this.plotterConfigTypeList = data;
    },
    // 下载
    async download(row) {
      const a = disablePrompt();
      if (a) {
        print.downloadPlotterConfig(row.id).then((response) => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(row.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$left-width: 226px;
$header-height: 46px;
#projetsetup {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  .right {
    height: 100%;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .right_header {
      border-bottom: 1px solid #ebefff;
      font-size: 16px;
      font-weight: 600;
      color: var(--key-color);
      padding: var(--middle-space) var(--big-space);
    }
    .right_button {
      padding: var(--middle-space) var(--big-space);
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .right_table {
      height: 1px;
      flex-grow: 1;
      padding: 0 var(--big-space) var(--middle-space);
    }
  }
}
.upload-file{
  /deep/ .el-upload-list {
    display: block !important;
  }
}
</style>
